// Window dimensions
export const DEFAULT_WINDOW_WIDTH = 400;
export const DEFAULT_WINDOW_HEIGHT = 600;
export const MIN_WINDOW_WIDTH = 320;
export const MIN_WINDOW_HEIGHT = 300;
export const MAX_WINDOW_WIDTH = 1569;
export const MAX_WINDOW_HEIGHT = 888;
export const DEFAULT_DRAWER_WIDTH = 400;
export const MIN_DRAWER_WIDTH = 320;
export const MAX_DRAWER_WIDTH = 1569;
